import { Checkbox } from '@ads/components-react';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { BannerFormValues } from '../../../types/bannerForm';
import { BannerFormSection } from '../../molecules/BannerFormSection';

export interface BannerDisplaySectionProps {
  readonly control: Control<BannerFormValues>;
}

/** Campos booleanos do bloco Exibição, na ordem do protótipo. */
const DISPLAY_FIELDS = [
  { name: 'showTitle', labelKey: 'banner.form.display.showTitle' },
  { name: 'general', labelKey: 'banner.form.display.general' },
  { name: 'active', labelKey: 'banner.form.display.active' },
  { name: 'isMonograph', labelKey: 'banner.form.display.monograph' },
  { name: 'isMonitor', labelKey: 'banner.form.display.monitor' },
] as const satisfies readonly {
  readonly name: keyof BannerFormValues;
  readonly labelKey: string;
}[];

/**
 * Bloco "Exibição" do formulário de Banner: exibir título sobre a mídia, Geral
 * (todas as turmas), Ativo, TCC e Visualização monitores.
 *
 * Desmarcar "Geral" é o que revela o bloco Turmas no template.
 */
export function BannerDisplaySection({ control }: BannerDisplaySectionProps) {
  const { t } = useTranslation('banner');

  return (
    <BannerFormSection title={t('banner.form.display.heading')}>
      <div className="grid grid-cols-1 gap-micro sm:grid-cols-2">
        {DISPLAY_FIELDS.map(field => (
          <Controller
            key={field.name}
            control={control}
            name={field.name as 'showTitle'}
            render={({ field: controlled }) => (
              <Checkbox
                checked={controlled.value}
                size="md"
                label={t(field.labelKey as 'banner.form.display.showTitle')}
                onCheckedChange={checked => {
                  if (checked !== 'indeterminate') controlled.onChange(checked);
                }}
              />
            )}
          />
        ))}
      </div>
    </BannerFormSection>
  );
}
